import EntityContainer from './EntityContainer';
import { GameDataHandler } from '../GameDataHandler';
import ChunkBase from './ChunkBase';
import { app } from '../core/App';
import { BodyTypes } from './LevelManager';
import { Player } from '../Player';
export default class EntityGem extends EntityContainer {
  protected chunk: ChunkBase | undefined;
  protected isInitialised: boolean;
  protected isMagnetised: boolean;
  protected hasCollided: boolean;

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 23.5, y ?? 10);

    this.isInitialised = false;
    this.isMagnetised = false;
    this.hasCollided = false;
  }

  get IsMagnetised() {
    return this.isMagnetised;
  }

  get HasCollided() {
    return this.hasCollided;
  }

  public init() {
    if (this.isInitialised) return;

    this.injectMatter(this);
    this.isInitialised = true;
  }

  public bindChunk(chunk: ChunkBase) {
    this.chunk = chunk;
  }

  public reset() {
    this.alpha = 1;
    this.scale = 1;
    this.setVisible(true);
    this.setActive(true);

    this.hasCollided = false;
    this.isMagnetised = false;

    // this.gem.setFrame(EntitySmallGem.gemFrames[Phaser.Math.Between(0, EntitySmallGem.gemFrames.length - 1)]);
  }

  public collect() {
    this.score();

    this.scene.add.tween({
      targets: this,
      y: '+=-150',
      alpha: { from: 1, to: 0, duration: 1000 },
      duration: 400,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.recycle,
      onCompleteParams: [true],
      onCompleteScope: this
    });

    this.hasCollided = true;
    // app.audioHandler.playSound(this.scene, 'SndGemCollect', 'sfx');
  }

  public recycle(removeFromChunk: boolean = false) {
    // console.log('Recycling Gem!');

    this.scene?.tweens?.killTweensOf(this);
    this.setVisible(false);
    this.setActive(false);
    this.setPosition(-1000, 0);

    if (removeFromChunk) this.chunk?.removeEntity(this);
    this.chunk = undefined;
  }

  protected injectMatter(target: Phaser.GameObjects.GameObject) {
    let x = this.x;
    let y = this.y;

    // this.setSize(this.gem.displayWidth, this.gem.displayHeight);

    let matterSprite = this.scene.matter.add.gameObject(target, {
      isStatic: true,
      isSensor: true,
      onCollideCallback: this.onCollision.bind(this)
    }) as Phaser.Physics.Matter.Sprite;

    this.scene.matter.body.setPosition(target.body as MatterJS.BodyType, this.scene.matter.vector.create(x, y));
    this.scene.matter.setVelocity(target.body as MatterJS.BodyType, 0, 0);
  }

  protected onCollision(pair: MatterJS.ICollisionPair) {
    if (this.hasCollided) return;

    if ((pair.bodyA as MatterJS.BodyType).label == BodyTypes.GemMagnet) {
      this.onMagnetCollisionStart(pair, pair.bodyB as MatterJS.BodyType, pair.bodyA as MatterJS.BodyType);
    } else if ((pair.bodyB as MatterJS.BodyType).label == BodyTypes.GemMagnet) {
      this.onMagnetCollisionStart(pair, pair.bodyA as MatterJS.BodyType, pair.bodyB as MatterJS.BodyType);
    } else {
      this.collect();
    }
  }

  protected onMagnetCollisionStart(pair: MatterJS.ICollisionPair, gem: MatterJS.BodyType, magnet: MatterJS.BodyType) {
    if (!this.isMagnetised && magnet.gameObject instanceof Player) {
      this.isMagnetised = true;
      magnet.gameObject.addMagnetisedGem(this);
    }
  }

  protected score() {}
}
